import {
  AOBO_BUYER_CODE_DETAILS,
  AOBO_COMP_CODE,
  AOBO_DOWNLOAD,
  AOBO_GRAPH_DATA_TIMELINE,
  AOBO_GRAPH_DATA_VALUE_QTY,
  AOBO_PART_DETAILS,
  AOBO_RANGE,
  AOBO_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getAOBORange = (
  orderType,
  department,
  compCode,
  buyerList,
  filterType
) => {
  const requestURL = AOBO_RANGE;
  let obj = { filter_type: filterType };

  if (orderType && orderType.length) {
    obj["order_type_list"] = orderType.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }
  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBuyerCodeDetails = (page, limit, deptList = null, search) => {
  let requestURL = AOBO_BUYER_CODE_DETAILS;
  let obj = {};

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (limit) {
    obj["limit"] = limit;
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCompCode = () => {
  let requestURL = AOBO_COMP_CODE;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAOBOReport = (
  orderType,
  department,
  compCode,
  buyerList,
  filterType,
  category,
  dayRangeList,
  rangeValue,
  parts
) => {
  const requestURL = AOBO_DOWNLOAD;
  let obj = { filter_type: filterType};

  if (orderType && orderType.length) {
    obj["order_type_list"] = orderType.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }
  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }
  if (dayRangeList && dayRangeList.length) {
    obj["day_range_list"] = dayRangeList.join(",");
  }
  if (category && category.length) {
    obj["category"] = category.join(",");
  }
  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }
  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAOBOGraphDataTimeline = (
  page,
  limit,
  aggr,
  orderType,
  department,
  compCode,
  buyerList,
  dayRangeList,
  category,
  parts
) => {
  const requestURL = AOBO_GRAPH_DATA_TIMELINE;
  //aggr - comp_code, dept
  //category - TKML, EXPORT
  let obj = { aggregate_column: aggr, category: category };

  if (orderType && orderType.length) {
    obj["order_type_list"] = orderType.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }
  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }
  if (dayRangeList && dayRangeList.length) {
    obj["day_range_list"] = dayRangeList.join(",");
  }
  if (page) {
    obj["page"] = page;
  }
  if (limit) {
    obj["limit"] = limit;
  }
  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAOBOGraphDataValueQty = (
  page,
  limit,
  aggr,
  orderType,
  department,
  compCode,
  buyerList,
  filterType,
  category,
  rangeValue,
  parts
) => {
  const requestURL = AOBO_GRAPH_DATA_VALUE_QTY;
  //aggr - comp_code, dept
  //category - TKML, EXPORT
  let obj = {
    aggregate_column: aggr,
    filter_type: filterType,
    category: category,
    range_value: rangeValue,
  };

  if (orderType && orderType.length) {
    obj["order_type_list"] = orderType.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }
  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }
  if (page) {
    obj["page"] = page;
  }
  if (limit) {
    obj["limit"] = limit;
  }
  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAOBOTableData = (
  page,
  limit,
  orderType,
  department,
  compCode,
  buyerList,
  filterType,
  category,
  dayRangeList,
  rangeValue,
  parts
) => {
  const requestURL = AOBO_TABLE_DATA;
  //aggr - comp_code, dept
  //category - TKML, EXPORT
  let obj = {
    filter_type: filterType,
    category: category,
  };

  if (orderType && orderType.length) {
    obj["order_type_list"] = orderType.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }
  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }
  if (dayRangeList && dayRangeList.length) {
    obj["day_range_list"] = dayRangeList.join(",");
  }
  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }
  if (page) {
    obj["page"] = page;
  }
  if (limit) {
    obj["limit"] = limit;
  }
  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPartDetails = (
  deptList = null,
  buyerList = null,
  page,
  search
) => {
  let requestURL = AOBO_PART_DETAILS;
  let obj = {};
  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};